module.exports = "<h3>current version: {{current_version}}</h3>\r\n\r\n"